/**
 * vue-sparklines v2.0.1
 * (c) 2022 tangzhen@me.com
 * @license MIT
 */

var SIZE = 256;
var idx = SIZE;
var hex = [];
var buffer;

while (idx--) {
  hex[idx] = (idx + SIZE).toString(16).substring(1);
}

var uid = (function (len) {
  var tmp = len || 11;
  var i = 0;

  if (!buffer || idx + tmp > SIZE * 2) {
    for (buffer = "", idx = 0; i < SIZE; i++) {
      buffer += hex[Math.random() * SIZE | 0];
    }
  }

  return buffer.substring(idx, idx++ + tmp);
});

export { uid as default };
//# sourceMappingURL=uid.js.map
